module.exports = {
      id: "ShapeList-usage",
      viewBox: "0 0 705.609 643.771",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#ShapeList-usage",
      toString: function () {
        return this.url;
      }
    }